import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
export function Experimental__IconPlay(props) {
  var iconList = [{
    "size": 16,
    "svgContent": "<path d=\"M4.018 14L14.41 8 4.018 2z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M6 21l15.589-9L6 3z\"/>"
  }, {
    "size": 32,
    "svgContent": "<path d=\"M9.5 27.134l17.785-10.268a1 1 0 000-1.732L9.5 4.866a1 1 0 00-1.5.866v20.536a1 1 0 001.5.866z\"/>"
  }, {
    "size": 48,
    "svgContent": "<path d=\"M15 40.268l25.177-14.536c1.333-.77 1.333-2.694 0-3.464L15 7.732c-1.333-.77-3 .193-3 1.732v29.072c0 1.54 1.667 2.502 3 1.732z\"/>"
  }, {
    "size": 64,
    "svgContent": "<path d=\"M19 54.268l35.57-20.536c1.333-.77 1.333-2.694 0-3.464L19 9.732c-1.333-.77-3 .192-3 1.732v41.072c0 1.54 1.667 2.502 3 1.732z\"/>"
  }];
  var iconListRedraw = [{
    "size": 16,
    "svgContent": "<path d=\"M3 1.713a.7.7 0 011.05-.607l10.89 6.288a.7.7 0 010 1.212L4.05 14.894A.7.7 0 013 14.288V1.713z\"/>"
  }, {
    "size": 24,
    "svgContent": "<path d=\"M7.05 3.606l13.49 7.788a.7.7 0 010 1.212L7.05 20.394A.7.7 0 016 19.788V4.212a.7.7 0 011.05-.606z\"/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.next ? iconListRedraw : iconListFallback, props.iconSize || 24);
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: closestSize.svgContent
    }
  }));
}
export default Experimental__IconPlay;